<template>
  <div>
    <v-layout wrap>
      <v-flex >
        <c-search-form
            :rows-per-page-items="[10, 20, 50]"
            :form-name="formName"
            :fields="fields"
            :hiddenFields="hiddenFields"
            key-property="classId"
            search-url="/kidClass/listClass"
            create-url="/kidClass/save"
            delete-url="/kidClass/delete"
            form-type="intable"
            custom-create-new
            @createNew="openCreateDialog"
            custom-edit-item
            @editItem="openCreateDialog"
            ref="tableData"
            :reload="timeReload"
            :deleteMulti="false"
            orderBy="desc"
            :acceptDelete="false"
            :acceptView="true"
            @viewItem="viewItem"
        >
        </c-search-form>
        <!--            search-url="/kidClass/search/?sortField=status,classId&"-->
        <material-type-group-create
            :propsItem="category"
            :cDialog="visibleCreateDialog"
            @closeCreateDialog="closeCreateDialog"
            :formCreateName="formCreateName"
            :hiddenFields="hiddenFields"
        />
      </v-flex>
    </v-layout>
  </div>

</template>

<script>
import CSearchForm from "../../../components/form/ManageForm";
import {areaContants, cateContants} from "@/constants";
import axios from "axios";
import MaterialTypeGroupCreate from "@/views/admin/class/ClassCreate";
import {classIsActive} from "@/constants/cateContants";

export default {
  name: "warehouse",
  components: {MaterialTypeGroupCreate, CSearchForm},
  data: () => {
    return {
      formName: "Thông tin lớp học",
      formCreateName: "Thêm mới lớp học",
      category: null,
      lastSearchValues: {},
      visibleCreateDialog: false,
      timeReload: 0,
      hiddenFields: {
        typeId: "0",
      },
      fields: [
        {
          value: "index",
          text: "lang.common.index",
          width: "5%",
          sortable: false,
          headerStyle: "text-align:center",
        },
/*        {
          value: 'classId',
          text: 'Mã lớp',
          sortable: false,
          search: true,
          width: "5%",
          headerStyle: "text-align:center",
        },*/
        {
          value: 'className',
          text: 'Tên lớp',
          sortable: false,
          search: true,
          width: "20%",
          headerStyle: "text-align:center",
        },
        {
          value: 'programId',
          text: 'Khung chương trình',
          width: "10%",
          sortable: false,
          search: true,
          headerStyle: "text-align:center",
          type: "select",
          name: "programId",
          items: [],
          itemText: "programName",
          itemValue: "programId",
        },
        {
          value: 'accountZaloId',
          text: 'Tài khoảng zalo',
          width: "10%",
          sortable: false,
          search: true,
          headerStyle: "text-align:center",
          type: "select",
          name: "accountZaloId",
          items: [],
          itemText: "accountZaloName",
          itemValue: "accountZaloId",
        },
        {
          value: 'classLink',
          text: 'Link lớp học',
          sortable: false,
          type: "link",
          search: true,
          width: "10%",
          headerStyle: "text-align:center",
        },
        {
          value: 'startDate',
          text: 'Ngày khai giảng',
          type: "date",
          sortable: true,
          search: true,
          width: "20%",
          dateFormat: 'dd/MM/yyyy',
          headerStyle: "text-align:center",
          fromDate: "fromDate",
          toDate: "toDate"
        },
        {
          value: "isActive",
          text: "Trạng thái",
          search: true,
          headerStyle: "text-align:center",
          type: "select",
          name: "isActive",
          items: cateContants.classIsActive,
          itemText: "text",
          itemValue: "value",
          width: "10%",
        },
        {
          value: "action",
          text: "lang.common.actions",
          sortable: false,
          compound: true,
          width: "10%",
          headerStyle: "text-align:center",
        },
      ],
    };
  },

  created() {
    axios.post(
        process.env.VUE_APP_API_URL + "/kidProgram/listAllName", {status: 1}
    )
        .then(
            (data) => {
              let itemFields = this.fields.filter(function (e) {
                return e.name == "programId";
              });
              if (itemFields != undefined && itemFields.length > 0) {
                itemFields[0].items = data;
              }
            }
        );

    axios.post(
        process.env.VUE_APP_API_URL + "/kidAccountZalo/listAllName", {status: 1}
    )
        .then(
            (data) => {
              let itemFields = this.fields.filter(function (e) {
                return e.name == "accountZaloId";
              });
              if (itemFields != undefined && itemFields.length > 0) {
                itemFields[0].items = data;
              }
            }
        );
  },

  methods: {
    clearFromDate() {
      this.hiddenFields.fromDate = null;
    },
    clearToDate() {
      this.hiddenFields.toDate = null;
    },
    onChangeFromDate(date) {
      this.hiddenFields.fromDate = date;
    },
    onChangeToDate(date) {
      this.hiddenFields.toDate = date;
    },
    openCreateDialog: function (item = null) {
      if (item == null) {
        this.formCreateName = 'Thêm mới lớp học';
        this.getNextCode();
      } else {
        this.category = item;
        this.formCreateName = 'Cập nhật lớp học';
        this.visibleCreateDialog = true;
      }
    },
    closeCreateDialog: function () {
      this.category = null;
      this.visibleCreateDialog = false;
      this.timeReload = Math.floor(Math.random() * 100);
    },

    getNextCode: function () {
      axios.get(
          process.env.VUE_APP_API_URL +
          "/autoIncrease/getNextNumber?type=MATERIAL_TYPE_ALLY"
      )
          .then((data) => {
            this.category = Object.assign({}, this.category, {"categoryCode": "MATERIAL_TYPE_ALLY" + data, "status": 1})
            this.visibleCreateDialog = true;
          });
    },
    createParamLastSearch: function (values) {
      const obj1 = {
        searchImportRequest: JSON.stringify(values),
      };
      const obj2 = this.$route.query;
      return {...obj1, ...obj2};
    },
    viewItem: function (item) {
      this.$router.push({
        path: '/class/view/' + item.classId, query: this.createParamLastSearch(this.lastSearchValues)
      });
    },
  },

  destroyed() {
  },
};
</script>
